<template>
  <FormWrapper
    :handleSubmit="handleSubmit"
    :loading="submitLoading"
    :isSubmitButton="checkPermission(PERMISSIONS, ['admin', 'edit'])"
    :bodyClass="`${
      !GET_LOADING ? 'padding-x-16' : ''
    } padding-y-16 height--max-content margin-bottom-100`"
  >
    <FormLoading :loading="GET_LOADING" :count="8">
      <Input
        :title="$lang.title"
        :label="$lang.title"
        :placeholder="$lang.title"
        :value="form.title"
        name="title"
        id="title"
        type="text"
        :vuelidateObj="$v.form.title"
        :disabled="isNotEditingWhenExecutedCenterExecute"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
      <Dropdown
        :title="$lang.company"
        :label="$lang.company"
        :placeholder="$lang.company"
        :value="form.company"
        name="company"
        id="company"
        :vuelidateObj="$v.form.company"
        :asyncSearch="getCompanyCombo"
        :insideFeature="true"
        :disabled="true"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
        @change="getTermOptions"
      />
      <Dropdown
        :title="$lang.selectTerm"
        :label="$lang.selectTerm"
        :placeholder="$lang.selectTerm"
        :value="form.term"
        name="term"
        id="term"
        :vuelidateObj="$v.form.term"
        :options="termOptions"
        :loading="termLoading"
        :disabled="true"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
        @change="getTemplateOptions"
      />
      <Dropdown
        :title="$lang.template"
        :label="$lang.template"
        :placeholder="$lang.template"
        :value="form.template"
        name="template"
        id="template"
        :vuelidateObj="$v.form.template"
        :loading="templateLoading"
        :options="templateOptions"
        :disabled="true"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
        @change="getAssessmentPlanOptions"
      />
      <Dropdown
        :title="$lang.assessmentPlan"
        :label="$lang.assessmentPlan"
        :placeholder="$lang.assessmentPlan"
        :value="form.assessmentPlan"
        name="assessmentPlan"
        id="assessmentPlan"
        :vuelidateObj="$v.form.assessmentPlan"
        :loading="assessmentPlanLoading"
        :options="assessmentPlanOptions"
        :disabled="true"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
      <DatePicker
        :title="$lang.startDate"
        :label="$lang.startDate"
        :placeholder="$lang.startDate"
        :value="form.startDate"
        name="startDate"
        id="startDate"
        rightIcon="calendar-clock"
        displayFormat="jYYYY/jMM/jDD"
        format="YYYY-MM-DD"
        type="date"
        :popover="true"
        :simple="true"
        :autoSubmit="true"
        :hasEraseIcon="true"
        :disabled="isNotEditingCenterExecuteStatus"
        :vuelidateObj="$v.form.startDate"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
        @erase="input"
      />
      <Checkbox
        v-if="isCenterExecuteTypeVirtual"
        :label="$lang.floatingByStartTime"
        :value="form.floatingByStartTime"
        :infoTooltip="$lang.floatingByStartTimeTooltip"
        :disabled="isNotEditingCenterExecuteStatus"
        name="floatingByStartTime"
        hoverClass=""
        @input="input"
      />
      <div
        class="font-size-14 color-complementary-300 background-double-light-gray padding-8 border-radius-8 margin-bottom-16"
      >
        {{ $lang.delayTime }}:
        {{ form.startDelay }}
        {{ $lang.minute }}
      </div>
      <EnumDropdown
        :title="$lang.personShowCompleteData"
        :label="$lang.personShowCompleteData"
        :placeholder="$lang.personShowCompleteData"
        :infoTooltip="$lang.personShowCompleteDataTooltip"
        :value="form.personShowCompleteData"
        name="personShowCompleteData"
        id="personShowCompleteData"
        categoryName="person_show_complete_data"
        :multiple="false"
        :vuelidateObj="$v.form.personShowCompleteData"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
      <EnumDropdown
        :title="$lang.centerExecuteType"
        :label="$lang.centerExecuteType"
        :placeholder="$lang.centerExecuteType"
        :infoTooltip="$lang.centerExecuteTypeTooltip"
        :value="form.centerExecuteType"
        name="centerExecuteType"
        id="centerExecuteType"
        categoryName="center_execute_type"
        :multiple="false"
        :vuelidateObj="$v.form.centerExecuteType"
        :disabled="isNotEditingCenterExecuteStatus"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
      <EnumDropdown
        :title="$lang.createReportMethod"
        :label="$lang.createReportMethod"
        :placeholder="$lang.createReportMethod"
        :infoTooltip="$lang.createReportMethodTooltip"
        :value="form.createReportMethod"
        name="createReportMethod"
        id="createReportMethod"
        categoryName="report_card_production_method"
        :multiple="false"
        :vuelidateObj="$v.form.createReportMethod"
        :disabled="isNotEditingCenterExecuteStatus"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
      <EnumDropdown
        :title="$lang.indicatorVerificationStatus"
        :label="$lang.indicatorVerificationStatus"
        :placeholder="$lang.indicatorVerificationStatus"
        :value="form.indicatorVerificationStatus"
        name="indicatorVerificationStatus"
        id="indicatorVerificationStatus"
        categoryName="indicator_verification_method"
        :multiple="false"
        :vuelidateObj="$v.form.indicatorVerificationStatus"
        :disabled="isNotEditingCenterExecuteStatus"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
      <EnumDropdown
        :title="$lang.competencyScoring"
        :label="$lang.competencyScoring"
        :placeholder="$lang.competencyScoring"
        :value="form.competencyScoring"
        name="competencyScoring"
        id="competencyScoring"
        categoryName="competency_scoring_method"
        :multiple="false"
        :vuelidateObj="$v.form.competencyScoring"
        :disabled="isNotEditingCenterExecuteStatus"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
      <EnumDropdown
        :title="$lang.competencySuggestionValueMethod"
        :label="$lang.competencySuggestionValueMethod"
        :placeholder="$lang.competencySuggestionValueMethod"
        :value="form.competencySuggestionValueMethod"
        name="competencySuggestionValueMethod"
        id="competencySuggestionValueMethod"
        categoryName="competency_suggestion_value_method"
        :multiple="false"
        :vuelidateObj="$v.form.competencySuggestionValueMethod"
        :disabled="
          isNotEditingCenterExecuteStatus && isNotPreExecuteCenterExecuteStatus
        "
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
      <Checkbox
        :label="$lang.hasSample"
        :value="form.hasSample"
        name="hasSample"
        :disabled="isNotEditingWhenExecutedCenterExecute"
        @input="input"
      />
      <Checkbox
        :label="$lang.sessionRecord"
        :value="form.hasVoiceRecording"
        name="hasVoiceRecording"
        @input="input"
      />
      <Checkbox
        :label="$lang.washupAction"
        :value="form.hasWashup"
        name="hasWashup"
        @input="input"
      />
      <Checkbox
        :label="$lang.candidateSearchWithNationalCode"
        :value="form.candidateSearchWithNationalCode"
        name="candidateSearchWithNationalCode"
        @input="input"
      />
      <Checkbox
        :label="$lang.executivePersonSearchWithNationalCode"
        :value="form.executivePersonSearchWithNationalCode"
        name="executivePersonSearchWithNationalCode"
        @input="input"
      />
      <Checkbox
        :label="$lang.sendSmsToExecutive"
        :value="form.sendSmsToExecutive"
        :infoTooltip="$lang.sendSmsToExecutiveOrCandidateInfo"
        name="sendSmsToExecutive"
        :disabled="isNotEditingCenterExecuteStatus"
        @input="input"
      />
      <Checkbox
        :label="$lang.sendSmsToCandidate"
        :value="form.sendSmsToCandidate"
        :infoTooltip="$lang.sendSmsToExecutiveOrCandidateInfo"
        name="sendSmsToCandidate"
        :disabled="isNotEditingCenterExecuteStatus"
        @input="input"
      />
      <Dropdown
        :title="`${$lang.executivePersonTermFilter} (${$lang.optional})`"
        :label="$lang.executivePersonTermFilter"
        :placeholder="$lang.executivePersonTermFilter"
        :infoTooltip="$lang.executivePersonTermFilterTooltip"
        :value="form.executivePersonTermFilter"
        name="executivePersonTermFilter"
        id="executivePersonTermFilter"
        :vuelidateObj="$v.form.executivePersonTermFilter"
        :asyncSearch="getTermOptions2"
        :insideFeature="true"
        :multiple="true"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
      <Input
        :title="$lang.description"
        :label="$lang.description"
        :placeholder="$lang.description"
        :value="form.description"
        name="description"
        id="description"
        type="textarea"
        :vuelidateObj="$v.form.description"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
    </FormLoading>
  </FormWrapper>
</template>
<script>
import inputMixin from "@/mixin/inputMixin.vue";
import {
  FormWrapper,
  FormLoading,
  Input,
  Dropdown,
  DatePicker,
  Checkbox,
  EnumDropdown,
} from "@/components/re-design/forms";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateError, toastAlert, checkPermission } from "@/shared/utils";
import {
  getAssessmentPlanCombo,
  getCompanyCombo,
  getTemplateCombo,
  getTermCombo,
} from "@/services";
import { updateCenterExecute } from "@/modules/kanoon/services";
export default {
  mixins: [inputMixin],
  inject: ["GET_LOADING", "CENTER_EXECUTE_DATA", "PERMISSIONS"],
  components: {
    FormWrapper,
    FormLoading,
    Input,
    Dropdown,
    DatePicker,
    Checkbox,
    EnumDropdown,
  },
  validations() {
    return {
      form: {
        title: { required },
        company: { required },
        term: { required },
        template: { required },
        assessmentPlan: { required },
        startDate: { required },
        personShowCompleteData: { required },
        centerExecuteType: { required },
        createReportMethod: { required },
        indicatorVerificationStatus: { required },
        competencyScoring: { required },
        competencySuggestionValueMethod: { required },
        executivePersonTermFilter: {},
        description: {},
      },
    };
  },
  data() {
    return {
      form: {
        title: null,
        company: null,
        term: null,
        template: null,
        assessmentPlan: null,
        startDate: null,
        floatingByStartTime: false,
        startDelay: 0,
        personShowCompleteData: null,
        centerExecuteType: null,
        createReportMethod: null,
        indicatorVerificationStatus: null,
        competencyScoring: null,
        competencySuggestionValueMethod: null,
        hasVoiceRecording: false,
        hasWashup: false,
        hasSample: false,
        candidateSearchWithNationalCode: false,
        executivePersonSearchWithNationalCode: false,
        executivePersonTermFilter: [],
        description: null,
        sendSmsToExecutive: false,
        sendSmsToCandidate: false,
      },
      submitLoading: false,
      termLoading: false,
      termOptions: [],
      templateLoading: false,
      templateOptions: [],
      assessmentPlanLoading: false,
      assessmentPlanOptions: [],
    };
  },
  computed: {
    isCenterExecuteTypeVirtual() {
      return pathOr(null, ["centerExecuteType", "id"], this.form) === 1;
    },
    isNotEditingCenterExecuteStatus() {
      return pathOr(null, ["status", "id"], this.CENTER_EXECUTE_DATA) !== 1;
    },
    isNotPreExecuteCenterExecuteStatus() {
      return pathOr(null, ["status", "id"], this.CENTER_EXECUTE_DATA) !== 2;
    },
    isNotEditingWhenExecutedCenterExecute() {
      return pathOr(null, ["status", "id"], this.CENTER_EXECUTE_DATA) >= 3;
    },
  },
  watch: {
    CENTER_EXECUTE_DATA: {
      immediate: true,
      handler(data) {
        if (data) {
          // set server data to form
          for (const [key] of Object.entries(this.form)) {
            this.input(key, data[key]);
          }
        }
      },
    },
  },
  methods: {
    pathOr,
    checkPermission,
    getCompanyCombo,
    handleReload() {
      this.$emit("handleReload");
    },
    async getTermOptions() {
      const companyCode = pathOr(null, ["company", "id"], this.form);
      if (!companyCode) return;

      try {
        this.termLoading = true;
        const extraQueryString = { company_code: companyCode };
        const response = await getTermCombo(null, extraQueryString);
        const { options } = response;
        this.termOptions = options.map((option) => {
          return {
            ...option,
            id: pathOr(null, ["code"], option),
          };
        });
      } catch (error) {
        generateError(error);
      } finally {
        this.termLoading = false;
      }
    },
    async getTermOptions2(text = null) {
      try {
        const extraQueryString = { type: 2 };
        const response = await getTermCombo(text, extraQueryString);
        const { options } = response;
        return options;
      } catch (error) {
        generateError(error);
      }
    },
    async getTemplateOptions() {
      const companyCode = pathOr(null, ["company", "id"], this.form);
      if (!companyCode) return;

      try {
        this.templateLoading = true;
        const queryString = {
          "company_code[]": companyCode,
          completed: true,
        };
        const response = await getTemplateCombo(queryString);
        const { options } = response;
        this.templateOptions = options;
      } catch (error) {
        generateError(error);
      } finally {
        this.templateLoading = false;
      }
    },
    async getAssessmentPlanOptions(text = null) {
      const templateId = pathOr(null, ["template", "id"], this.form);
      if (!templateId) return;

      try {
        this.assessmentPlanLoading = true;
        const response = await getAssessmentPlanCombo(templateId, text);
        const { options } = response;
        this.assessmentPlanOptions = options;
      } catch (error) {
        generateError(error);
      } finally {
        this.assessmentPlanLoading = false;
      }
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.submitLoading = true;
        const { id } = this.CENTER_EXECUTE_DATA;
        const {
          title,
          startDate,
          floatingByStartTime,
          hasVoiceRecording,
          hasWashup,
          hasSample,
          candidateSearchWithNationalCode,
          executivePersonSearchWithNationalCode,
          description,
          sendSmsToExecutive,
          sendSmsToCandidate,
        } = this.form;
        const personShowCompleteDataId = pathOr(
          null,
          ["personShowCompleteData", "id"],
          this.form
        );
        const centerExecuteTypeId = pathOr(
          null,
          ["centerExecuteType", "id"],
          this.form
        );
        const indicatorVerificationStatusId = pathOr(
          null,
          ["indicatorVerificationStatus", "id"],
          this.form
        );
        const competencyScoringId = pathOr(
          null,
          ["competencyScoring", "id"],
          this.form
        );
        const competencySuggestionValueMethodId = pathOr(
          null,
          ["competencySuggestionValueMethod", "id"],
          this.form
        );
        const createReportMethodId = pathOr(
          null,
          ["createReportMethod", "id"],
          this.form
        );
        const executivePersonTermFilter =
          this.form.executivePersonTermFilter.map(({ id }) => id);

        const response = await updateCenterExecute({
          id,
          title,
          startDate,
          floatingByStartTime: Number(floatingByStartTime),
          personShowCompleteDataId,
          centerExecuteTypeId,
          createReportMethodId,
          indicatorVerificationStatusId,
          competencyScoringId,
          competencySuggestionValueMethodId,
          hasVoiceRecording: +hasVoiceRecording,
          hasWashup: +hasWashup,
          hasSample: +hasSample,
          candidateSearchWithNationalCode: +candidateSearchWithNationalCode,
          executivePersonSearchWithNationalCode:
            +executivePersonSearchWithNationalCode,
          executivePersonTermFilter,
          description,
          sendSmsToExecutive: +sendSmsToExecutive,
          sendSmsToCandidate: +sendSmsToCandidate,
        });
        const { message } = response;
        toastAlert(message);
        this.handleReload();
      } catch (error) {
        generateError(error);
      } finally {
        this.submitLoading = false;
      }
    },
  },
};
</script>
